// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDiscountAltIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M21 9H2.26c-.38 0-.73.21-.9.55-.33.67.15 1.45.9 1.45H4.7a8.3 8.3 0 0 0 0 2H2.26c-.38 0-.73.21-.89.55-.34.67.14 1.45.89 1.45h2.9c1.24 3.49 4.56 6 8.48 6 1.74 0 3.36-.49 4.74-1.35.69-.43.82-1.39.24-1.97-.42-.42-1.07-.47-1.57-.15-.99.62-2.15.97-3.41.97A6.48 6.48 0 0 1 7.88 15h5.14c.38 0 .73-.21.89-.55.33-.66-.15-1.45-.89-1.45h-5.8c-.05-.33-.08-.66-.08-1s.03-.67.08-1H21c.55 0 1-.45 1-1s-.45-1-1-1M13.64 5.5c1.25 0 2.42.36 3.42.97.5.31 1.15.26 1.57-.16.58-.58.45-1.53-.25-1.96A9.03 9.03 0 0 0 13.64 3c-3.12 0-5.85 1.59-7.47 4h3.32c1.13-.94 2.57-1.5 4.14-1.5Z" />
  </g>
);
export default SvgDiscountAltIcon;
SvgDiscountAltIcon.displayName = 'SvgDiscountAltIcon';
